import { createFileRoute } from '@tanstack/react-router'
import { SpacesContainer } from 'src/containers/spaces/spaces-container'

export const Route = createFileRoute('/_layout/tenant/spaces/_layout')({
  component: SpacesContainer,
})
